<template lang="pug">
study-result-resolve-list.study-result-resolve(
  :moveReturnEvent='moveReturnEvent',
  :resultDetailTitle='resultDetailTitle',
  :images='images',
  :studyResultResolves='studyResultResolves',
  :showRetryButton='showRetryButton',
  :retryButtonEvent='retryButtonEvent',
  :retryEachButtonEvent='retryEachButtonEvent'
)
  template(#returnButtonText) 戻る
  template(#titleLabel) の結果
  template(#problemNumberHeader) 大問番号
  template(#questionNumberHeader) 小問番号
  template(#questionTypeHeader) 問題種別
  template(#correctAnswerHeader) 正解情報
  template(#correctSymbolHeader) テスト結果
  template(#resolveCorrectSymbolHeader) 解きなおし結果
  template(#retryHeader) 解きなおす
  template(#retryButtonText) もう一度挑戦
  template(#retryEachButtonText) 解きなおす
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import StudyResultResolveList from '@/components/templates/student/StudyResultResolveList.vue'
import { StudyResultDetailImage, StudyResultResolveType } from '@/models/studyResultDetailModel'
import { StudyResultUtils } from '@/utils/StudyResultUtils'
import StudentStudyResultDetailApi from '@/mixins/api/student/StudentStudyResultDetailApi'
import { SUnitCategorySetting } from '@/const/ApiSettings'

/**
 * テスト結果解きなおし画面
 */
@Component({
  components: {
    StudyResultResolveList,
  },
})
export default class StudyResultResolve extends Mixins(StudentStudyResultDetailApi) {
  // 小項目ID
  private get sUnitId(): number {
    return Number(this.$route.params.sUnitId)
  }

  // 結果詳細タイトル
  private resultDetailTitle = ''

  // 画像情報
  private images: StudyResultDetailImage[] = []

  // テスト結果解きなおし詳細表示情報
  private studyResultResolves: StudyResultResolveType[] = []

  // 再挑戦ボタン表示フラグ
  private showRetryButton = false

  /**
   * [Vue] 画面読み込み時：初期処理
   */
  private async mounted(): Promise<void> {
    // 結果詳細情報を取得
    this.$loading.start()

    this.images = await this.getStudentStudyResultImageUrl(this.sUnitId, SUnitCategorySetting.RESOLVE)
    const apiResponse = await this.getStudentStudyResultResolve(this.sUnitId)
    this.resultDetailTitle = StudyResultUtils.getStudyResultResolveTitle(apiResponse)
    this.studyResultResolves = StudyResultUtils.buildStudyResultResolves(apiResponse)
    // APIレスポンスが取得できなければ再挑戦ボタンは非表示
    this.showRetryButton = !!apiResponse
    this.$loading.complete()
  }

  // 戻るボタン押下時イベント
  private moveReturnEvent() {
    this.$router.push({ name: 'StudentStudyResult' })
  }

  // 再挑戦ボタン押下時イベント
  private retryButtonEvent() {
    // 学習済みフラグを持ってこの小項目の扉画面へ遷移
    this.$router.push({
      name: 'StudentStudyTop',
      query: {
        sUnitId: String(this.sUnitId),
        isLearned: 'true',
      },
    })
  }

  // 項目毎の解きなおすボタン押下時イベント
  private retryEachButtonEvent(problemNumber: number, questionNumber: number) {
    this.$logger.log(
      `retry each button pushed with problem number: ${problemNumber}, question number: ${questionNumber}`
    )
  }
}
</script>
